import { Component, Input} from '@angular/core';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    standalone: false
})
export class ErrorDialogComponent {

  @Input() errorMessages: string[] | null = null;

  trackByIndex(index: number): number {
    return index;
  }
}
